if (!window.sportovaFysik3dLauncher) {
  window.sportovaFysik3dLauncher = true;
  const beginLoading = (viewer) => {
    if (!viewer || ['frame-ready', 'crossfading', 'complete'].includes(viewer.dataset.transitionState)) return;
    viewer.classList.remove('pent-3d-viewer--ready');
    viewer.classList.add('pent-3d-viewer--loading');
    viewer.dataset.transitionState = 'runtime-loading';
    const poster = viewer.querySelector('.pent-3d-viewer__poster');
    const status = viewer.querySelector('.pent-3d-viewer__status');
    if (poster) poster.hidden = false;
    if (status) status.textContent = 'Loading 3D model…';
  };
  window.sportovaBeginPent3dLoading = beginLoading;
  const showMedia = (gallery, mediaId) => {
    const items = [...gallery.querySelectorAll('[id^="GalleryViewer"] .product__media-item[data-media-id]')];
    const active = items.find((item) => item.dataset.mediaId === mediaId);
    if (!active) return false;
    items.forEach((item) => {
      item.classList.toggle('is-active', item === active);
      item.toggleAttribute('aria-hidden', item !== active);
      item.querySelector('pent-3d-viewer')?.setActive?.(item === active);
    });
    gallery.querySelectorAll('[id^="GalleryThumbnails"] [data-target] button').forEach((button) => {
      button.toggleAttribute('aria-current', button.closest('[data-target]')?.dataset.target === mediaId);
    });
    return true;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.pent-3d-thumbnail');
    if (!button) {
      const imageThumbnail = event.target.closest('[id^="GalleryThumbnails"] [data-target] button');
      const imageViewer = imageThumbnail?.closest('media-gallery')?.querySelector('pent-3d-viewer');
      if (imageViewer) imageViewer.dataset.preferredView = 'image';
      return;
    }
    const gallery = button.closest('media-gallery');
    const viewer = gallery?.querySelector('pent-3d-viewer');
    if (!gallery || !viewer) return;
    if (viewer.dataset.modelMode !== 'fysik') return;
    window.initSportovaRequiredSwatches?.(document);
    viewer.dataset.preferredView = '3d';
    // Opening 3D is an explicit request to preview the first complete variant.
    // Preserve an already completed selection, including size/weight choices.
    const picker = document.querySelector(`variant-radios[data-section="${viewer.dataset.section}"], variant-selects[data-section="${viewer.dataset.section}"]`);
    const groups = [...(picker?.querySelectorAll('.product-form__input:has(.sportova-swatch)') || [])];
    if (picker && groups.some(group => group.dataset.sportovaSwatchTouched !== 'true')) {
      const variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
      const optionGroups = [...picker.querySelectorAll('fieldset, .product-form__input--dropdown')];
      const requested = optionGroups.map(group => {
        const preserve = !group.querySelector('.sportova-swatch') || group.dataset.sportovaSwatchTouched === 'true';
        return preserve ? (group.querySelector('input:checked')?.value || group.querySelector('select')?.value) : null;
      });
      const firstVariant = variants.find(variant => requested.every((value,index) => value == null || variant.options[index] === value)) || variants[0];
      if (!firstVariant) return;
      optionGroups.forEach((group, index) => {
        const value = firstVariant.options[index];
        group.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = input.value === value; });
        const select = group.querySelector('select');
        if (select) select.value = value;
        if (group.querySelector('.sportova-swatch')) {
          group.dataset.sportovaSwatchTouched = 'true';
          group.classList.remove('has-swatch-error');
          const error = group.querySelector('.sportova-swatch-error');
          if (error) error.hidden = true;
          group.querySelectorAll('.sportova-swatch').forEach(label => {
            label.classList.toggle('is-selected', document.getElementById(label.htmlFor)?.checked === true);
          });
        }
      });
      // Use the normal variant pipeline to update price, form ID and finishes.
      const input = picker.querySelector('input[type="radio"]:checked, select');
      input?.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const extra = document.querySelector(`[data-extra-finish-options][data-section="${viewer.dataset.section}"]`);
    extra?.querySelectorAll('.product-form__input').forEach(group => {
      group.dataset.sportovaSwatchTouched = 'true';
      group.querySelectorAll('.sportova-swatch').forEach(label => label.classList.toggle('is-selected', document.getElementById(label.htmlFor)?.checked === true));
    });
    picker?.closest('.sportova-product')?.querySelector('product-form form')?.dispatchEvent(new CustomEvent('sportova:swatches-changed', { bubbles:true }));
    gallery.querySelectorAll('.pent-3d-awaiting-selection').forEach(item => item.classList.remove('pent-3d-awaiting-selection'));
    beginLoading(viewer);
    if (!showMedia(gallery, viewer.dataset.galleryId)) return;
    if (!document.querySelector('script[data-pent3d-runtime]')) {
      const runtime = document.createElement('script');
      runtime.src = viewer.dataset.runtime;
      runtime.dataset.pent3dRuntime = 'true';
      runtime.addEventListener('load', () => viewer.activate?.(), { once: true });
      runtime.addEventListener('error', () => {
        runtime.remove();
        viewer.classList.remove('pent-3d-viewer--loading');
        viewer.dataset.transitionState = 'failed';
        const status = viewer.querySelector('.pent-3d-viewer__status');
        if (status) status.textContent = '3D view could not load';
      }, { once: true });
      document.head.appendChild(runtime);
    } else {
      viewer.activate?.();
    }
  }, true);
  document.addEventListener('change', (event) => {
    const picker = event.target.closest('variant-radios, variant-selects');
    if (!picker) return;
    window.setTimeout(() => {
      const groups = [...picker.querySelectorAll('.product-form__input:has(.sportova-swatch)')];
      const ready = groups.length > 0 && groups.every((group) => group.dataset.sportovaSwatchTouched === 'true');
      document.querySelectorAll(`pent-3d-viewer[data-section="${picker.dataset.section}"]`).forEach((viewer) => {
        const gallery = viewer.closest('media-gallery');
        const keep3dActive = viewer.dataset.preferredView === '3d' || viewer.closest('[data-media-id]')?.classList.contains('is-active');
        if (ready) {
          gallery?.querySelectorAll('.pent-3d-awaiting-selection').forEach((item) => item.classList.remove('pent-3d-awaiting-selection'));
          if (keep3dActive) showMedia(gallery, viewer.dataset.galleryId);
        } else if (viewer.dataset.fallbackMediaId) {
          viewer.dataset.preferredView = 'image';
          gallery?.querySelectorAll('[data-media-id*="pent-3d"]').forEach((item) => item.classList.add('pent-3d-awaiting-selection'));
          gallery?.setActiveMedia(viewer.dataset.fallbackMediaId, false);
        }
      });
    }, 0);
  });
}
